import React from "react";

export const selectFieldsForSearch = [
  { label: "Name", value: "name" },
  { label: "Email", value: "email" },
];
